import { useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';

import { GetExtendedVoucherWarningsPayload, getExtendedVoucherWarnings } from '~/services/PromoService';

type Params = {
  voucherIds: Array<string>;
  brand: GetExtendedVoucherWarningsPayload['brand'];
  enabled: boolean;
};

const EXTRA_CHECKS: NonNullable<GetExtendedVoucherWarningsPayload['extraChecks']> = [
  'check-voucher-user-expiry-after-voucher-expiry',
  'pending-translations',
];

export function useGetExtendedVoucherWarnings({ voucherIds, brand, enabled }: Params) {
  const ids = useMemo(() => [...new Set(voucherIds.filter(Boolean))].sort(), [voucherIds]);

  return useQuery({
    queryKey: ['vouchers', 'extended-warnings', brand, ids],
    queryFn: ({ signal }) =>
      getExtendedVoucherWarnings({ brand, voucherIds: ids, extraChecks: EXTRA_CHECKS }, { signal }),
    enabled: enabled && ids.length > 0,
    refetchOnWindowFocus: false,
    select: (response) => new Map(response.result.vouchers.map((voucher) => [voucher.voucherId, voucher])),
  });
}
